import { Injectable } from '@angular/core';
import { RootService } from '@app/core/root.service';
import { ItemProps } from '@app/interfaces';
import { Router } from '@angular/router';
import { ApiRequestService } from '@app/core/http/api-request.service';
import { Validators } from '@angular/forms';
import { PermissionsService } from '@app/core/permissions/permissions.service';
import { CustomValidators } from '@app/core/classes/custom-validators/custom-validators';
import { SharedService } from '@app/shared/services/shared.service';
import { ToArabicPipe } from '@app/shared/pipes/toArabic.pipe';
import { Observable, Subject } from 'rxjs';
import { UsersService } from '@app/users-feature/users.service';
import { split } from 'ts-node';

@Injectable({
  providedIn: 'root'
})
export class IndividualsDestructionService extends RootService {
  //reset neighborhoods list and value  after change district
  resetInput$ = new Subject();

  constructor(
    router: Router,
    api: ApiRequestService,
    shared: SharedService,
    permissionsService: PermissionsService,
    private toArabicPipe: ToArabicPipe,
    private usersService: UsersService
  ) {
    super(router, api, permissionsService, shared);
    this.permissionsKey = 'permission';

    this.lists['types'] = [
      {
        id: 'construction',
        name: 'اعمال بناء'
      },
      {
        id: 'demolition',
        name: 'هدم'
      },
      {
        id: 'restoration',
        name: 'ترميم'
      },
      {
        id: 'drilling_services',
        name: 'خدمات الحفر'
      },
      {
        id: 'municipality_projects',
        name: 'مشاريع البلدية'
      },
      {
        id: 'charity_projects',
        name: 'مشاريع خيرية'
      }
    ];
  }

  routerPrefix(val: string = '') {
    return val ? val : 'individual-permissions';
  }

  refactorItem(item: any) {
    return item;
  }
  navigateToList() {
    this.usersService.updateResources.next(null);
    return super.navigateToList();
  }

  refactorSelectListsResponse(listPrefix: string, response: any, listPaginate: boolean = false): any {
    if (listPrefix === 'types') {
      response.data = [
        {
          id: 'construction',
          name: 'construction'
        },
        {
          id: 'demolition',
          name: 'demolition'
        },
        {
          id: 'restoration',
          name: 'restoration'
        },
        {
          id: 'drilling_services',
          name: 'drilling_services'
        },
        {
          id: 'municipality_projects',
          name: 'municipality_projects'
        },
        {
          id: 'charity_projects',
          name: 'charity_projects'
        }
      ];
    }
    // console.log("listPrefix",listPrefix);
    if (listPrefix === 'permission_numbers') {
      // console.log(listPrefix);
      // console.log('demolition_serials');

      if (response.data && response.data.length) {
        response.data = response.data.map((item: any) => item['serial']);
      }
      // console.log(response.data);
    }
    this.loaded.next(true);

    if (response.data) {
      if (listPaginate) {
        return response;
      } else {
        return response.data;
      }
    }
  }
  refactorFormBeforeSubmit(formValue: any) {
    if (formValue['units'].length > 1) {
      const unitsLength = formValue['units'].length;
      if (!formValue['units'][unitsLength - 1]['plate_number']) {
        formValue['units'].pop();
      }
      formValue['units'].map((unit: any) => {
        unit['qr_code'] = unit['qr_code'] ? +unit['qr_code'] : null;
        unit['rfid'] = unit['rfid'] ? +unit['rfid'] : null;
        return unit;
      });
    }
    if (formValue.permission_date_input) {
      // console.log(formValue.permission_date)
      formValue.permission_date = this.shared.dateToCustomFormat(formValue.permission_date_input, 'DD-MM-YYYY');
      // console.log(formValue.permission_date)
    }
    if (formValue.owner_phone) {
      // formValue['owner_phone'] = parseInt(formValue.owner_phone);
      formValue['owner_phone'] = formValue.owner_phone;
    }
    // if (formValue.demolition_serial) {
    //   formValue['demolition_serial'] = parseInt(formValue.demolition_serial);
    // }
    // if (formValue.permission_number) {
    //   formValue['permission_number'] = parseInt(formValue.permission_number);
    // }

    if (formValue.national_id) {
      formValue['national_id'] = parseInt(formValue.national_id);
    }

    return formValue;
  }

  updateItemAsPost(id: any, data: {}) {
    return this.doUpdateItemAsPost('permissions/individual/append-units/' + id, data);
  }

  updateItem(id: any, data: {}) {
    return this.doUpdateItem('permissions/individual/append-units/' + id, data);
  }

  getRequest(url: string) {
    return this.api.request('GET', url, {}, {}, {});
  }
  onChangedValue(column: ItemProps, event: any) {
    super.onChangedValue(column, event);
    // console.log('col', column);
    // console.log('event', event);

    if (column.name === 'permission_number' && event) {
      this.loaded.next(false);
      this.getRequest('individual-permissions/details/' + event).subscribe(
        (res: any) => {
          if (res.data) {
            res.data['district_id'] = +res.data['district_id'];
            res.data['neighborhood_id'] = +res.data['neighborhood_id'];
            this.getRequest('districts/' + res.data['district_id'] + '/neighborhoods').subscribe((response: any) => {
              this.lists['neighborhoods'] = response.data;
              delete res.data['units'];
              this.shared.selectePermission$.next(res.data);
              this.loaded.next(true);
            });

            if (res.data['permission_date']) {
              const date = res.data['permission_date']
                .split('-')
                .reverse()
                .join('-');

              res.data['permission_date_input'] = date;
            }
          }
        },
        error => {
          this.shared.selectePermission$.next(null);
          this.loaded.next(true);
        },
        () => {}
      );
    }
    if (column.name === 'district_id' && event && event.id) {
      // tslint:disable-next-line:max-line-length
      this.lists['neighborhoods'] = [];
      this.resetInput$.next('neighborhood_id');
      this.getRequest('districts/' + event.id + '/neighborhoods').subscribe((res: any) => {
        this.lists['neighborhoods'] = res.data;
      });
    }
  }

  get featureProps(): ItemProps[] {
    return [
      {
        name: 'id',
        prop: 'id',
        form: {
          formFieldType: 'hidden'
        }
      },
      {
        name: 'permission_number',
        prop: 'serial',
        form: {
          Validators: [Validators.required, CustomValidators.numberValidator, Validators.maxLength(18)],
          formFieldType: 'ng_tag_select',
          listPrefix: 'permission_numbers',
          dataUrl: 'permissions/individual/serials',
          onChange: true,
          numberOnly: true,
          maxLength: 18,
          groupBy: {
            tabGroup: {
              tabGroupName: 'permission_group1',
              tabName: 'individual-permissions.permission_tab',
              steps: true
            }
          }
        }
      },
      {
        name: 'demolition_serial',
        prop: 'demolition_serial',
        form: {
          Validators: [Validators.minLength(8), Validators.maxLength(8), CustomValidators.numberValidator],
          formFieldType: 'text_number',
          minLength: 8,
          maxLength: 8,
          groupBy: {
            tabGroup: {
              tabGroupName: 'permission_group1',
              tabName: 'individual-permissions.permission_tab'
            }
          }
        }
      },
      {
        name: 'type',
        prop: 'type',
        form: {
          Validators: [Validators.required],
          formFieldType: 'ng_select',
          listPrefix: 'types',
          groupBy: {
            tabGroup: {
              tabGroupName: 'permission_group1',
              tabName: 'individual-permissions.permission_tab'
            }
          }
        }
      },
      {
        name: 'permission_date_input',
        prop: 'permission_date_input',
        form: {
          Validators: [Validators.required],
          formFieldType: 'datepicker',
          groupBy: {
            tabGroup: {
              tabGroupName: 'permission_group1',
              tabName: 'individual-permissions.permission_tab'
            }
          }
        }
      },
      {
        name: 'permission_date',
        prop: 'permission_date',
        form: {
          // Validators: [Validators.required],
          formFieldType: 'hidden',
          groupBy: {
            tabGroup: {
              tabGroupName: 'permission_group1',
              tabName: 'individual-permissions.permission_tab'
            }
          }
        }
      },
      {
        name: 'district_id',
        prop: 'district_id',
        form: {
          Validators: [Validators.required],
          formFieldType: 'ng_select',
          listPrefix: 'districts',
          dataUrl: 'districts?active=1',
          onChange: true,
          groupBy: {
            tabGroup: {
              tabGroupName: 'permission_group1',
              tabName: 'individual-permissions.permission_tab'
            }
          }
        }
      },
      {
        name: 'neighborhood_id',
        prop: 'neighborhood_id',
        form: {
          Validators: [Validators.required],
          formFieldType: 'ng_select',
          listPrefix: 'neighborhoods',
          groupBy: {
            tabGroup: {
              tabGroupName: 'permission_group1',
              tabName: 'individual-permissions.permission_tab'
            }
          }
        }
      },
      {
        name: 'street',
        prop: 'street',
        form: {
          Validators: [Validators.minLength(1), Validators.maxLength(50)],
          formFieldType: 'text',
          groupBy: {
            tabGroup: {
              tabGroupName: 'permission_group1',
              tabName: 'individual-permissions.permission_tab'
            }
          },
          minLength: 1,
          maxLength: 50
        }
      },
      {
        name: 'owner_name',
        prop: 'owner_name',
        form: {
          Validators: [Validators.required],
          formFieldType: 'text',
          groupBy: {
            tabGroup: {
              tabGroupName: 'permission_group1',
              tabName: 'individual-permissions.owner_tab'
            }
          }
        }
      },
      {
        name: 'national_id',
        prop: 'national_id',
        form: {
          Validators: [
            Validators.required,
            Validators.minLength(10),
            Validators.maxLength(10),
            Validators.pattern(/^[1-2][\d]+$/)
          ],
          formFieldType: 'text_number',
          groupBy: {
            tabGroup: {
              tabGroupName: 'permission_group1',
              tabName: 'individual-permissions.owner_tab'
            }
          },
          minLength: 10,
          maxLength: 10
        }
      },
      {
        name: 'owner_phone',
        prop: 'owner_phone',
        form: {
          Validators: [
            Validators.required,
            Validators.minLength(2),
            Validators.maxLength(6),
            CustomValidators.numberValidator
          ],

          formFieldType: 'text_number',
          groupBy: {
            tabGroup: {
              tabGroupName: 'permission_group1',
              tabName: 'individual-permissions.owner_tab'
            }
          },
          minLength: 2,
          maxLength: 6
        }
      },

      {
        name: 'units',
        prop: 'units',
        form: {
          formFieldType: 'formArray',
          name: 'units',
          groupBy: {
            tabGroup: {
              tabGroupName: 'permission_group1',
              tabName: 'individual-permissions.units'
            }
          },
          arrayForm: [
            {
              name: 'plate_number',
              prop: 'plate_number',
              list: {
                hidden: true
              },
              form: {
                Validators: [Validators.required, Validators.minLength(4), Validators.maxLength(8)],
                formFieldType: 'text',
                minLength: 4,
                maxLength: 8
              }
            },
            {
              name: 'qr_code',
              prop: 'qr_code',
              list: {
                hidden: true
              },
              form: {
                Validators: [Validators.required],
                formFieldType: 'text_number'
              }
            },
            {
              name: 'rfid',
              prop: 'rfid',
              list: {
                hidden: true
              },
              form: {
                Validators: [],
                formFieldType: 'text_number'
              }
            }
          ]
        }
      }
    ];
  }
}
